"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPlaylistV2Response = exports.mapPlaylistResponse = void 0;
const urls_1 = __importDefault(require("./urls"));
const ResourceClient_1 = require("./ResourceClient");
const PresentationClient_1 = require("./PresentationClient");
const ApplicationClient_1 = require("./ApplicationClient");
const ThemeClient_1 = require("./ThemeClient");
const mapObjectValues_1 = __importDefault(require("./mapObjectValues"));
const mapPlaylistItemResponse = (item) => {
    var _a, _b;
    return ({
        // Playlist item ids are auto-incrementing numbers but should probably be UUIDs in the future.
        // Covert to a string so that the consumer because we should treat it as a black box and not
        // rely on it being a number.
        id: String(item.id),
        presentationId: item.presentation_id,
        playlistId: item.playlist_id,
        // Handle the case where resource is null. This should never happen unless
        // someone is messing around with the DB manually.
        presentation: ((_a = item.presentation) === null || _a === void 0 ? void 0 : _a.resource)
            ? (0, PresentationClient_1.mapPresentationResponse)(item.presentation)
            : null,
        playlist: ((_b = item.playlist) === null || _b === void 0 ? void 0 : _b.resource) ? (0, exports.mapPlaylistResponse)(item.playlist) : null,
        order: item.order,
    });
};
const mapPlaylistResponse = (pl) => ({
    id: pl.id,
    name: pl.name,
    description: pl.description,
    tzid: pl.tzid,
    startDatetime: pl.start_datetime ? pl.start_datetime.replace(/Z/, '') : null,
    endDatetime: pl.end_datetime ? pl.end_datetime.replace(/Z/, '') : null,
    recurrenceRule: pl.recurrence_rule,
    scheduleType: pl.schedule_type,
    items: (pl.items || []).map(mapPlaylistItemResponse),
    isRuleOnItems: pl.is_rule_on_items,
    rule: pl.rule,
    resource: (0, ResourceClient_1.mapResourceResponse)(pl.resource),
});
exports.mapPlaylistResponse = mapPlaylistResponse;
const mapPlaylistV2Response = (pl) => ({
    id: pl.id,
    name: pl.name,
    mode: pl.mode,
    itemsPerPass: pl.items_per_pass,
    tzid: pl.tzid,
    startDatetime: pl.start_datetime,
    endDatetime: pl.end_datetime,
    recurrenceRule: pl.recurrence_rule,
    parentPlaylistId: pl.parent_playlist_id,
    scheduleType: pl.schedule_type,
    rule: pl.rule,
    isRuleOnItems: pl.is_rule_on_items,
    r: {
        resource: (0, ResourceClient_1.mapResourceV2Response)(pl.r.resource),
        playlistItems: (pl.r.playlist_items || []).map((item) => ({
            id: String(item.id),
            presentationId: item.item_presentation_id,
            playlistId: item.item_playlist_id,
            order: item.order,
            createdAt: item.created_at,
        })),
    },
});
exports.mapPlaylistV2Response = mapPlaylistV2Response;
class PlaylistClient {
    getPlaylists(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const isValidQueryParams = filter && filter.ids.length > 0;
            const filterQs = isValidQueryParams ? `?id=${filter === null || filter === void 0 ? void 0 : filter.ids.join(',')}` : '';
            const data = yield this.requestProtected({
                method: 'GET',
                url: `${urls_1.default.playlists()}${filterQs}`,
            });
            return data.map(exports.mapPlaylistResponse);
        });
    }
    createPlaylist(playlist) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.playlists(),
                body: {
                    name: playlist.name,
                    description: playlist.description,
                    schedule_type: playlist.scheduleType,
                    tzid: playlist.tzid,
                    start_datetime: playlist.startDatetime,
                    end_datetime: playlist.endDatetime,
                    recurrence_rule: playlist.recurrenceRule,
                    items: playlist.items
                        ? playlist.items.map((item) => ({
                            presentation_id: item.presentationId,
                            playlist_id: item.playlistId,
                        }))
                        : null,
                    is_rule_on_items: playlist.isRuleOnItems,
                    rule: playlist.rule,
                    resource: playlist.resource && {
                        r: playlist.resource.r && {
                            tags: (_a = playlist.resource.r.tags) === null || _a === void 0 ? void 0 : _a.map(ResourceClient_1.mapCreateTag),
                        },
                    },
                },
            });
            return (0, exports.mapPlaylistResponse)(data);
        });
    }
    updatePlaylist(playlistId, playlist) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.playlist(playlistId),
                body: {
                    name: playlist.name,
                    description: playlist.description,
                    schedule_type: playlist.scheduleType,
                    tzid: playlist.tzid,
                    start_datetime: playlist.startDatetime,
                    end_datetime: playlist.endDatetime,
                    recurrence_rule: playlist.recurrenceRule,
                    items: (_a = playlist.items) === null || _a === void 0 ? void 0 : _a.map((item) => ({
                        presentation_id: item.presentationId,
                        playlist_id: item.playlistId,
                    })),
                    is_rule_on_items: playlist.isRuleOnItems,
                    rule: playlist.rule,
                    resource: playlist.resource && {
                        r: ((_b = playlist.resource) === null || _b === void 0 ? void 0 : _b.r) && {
                            tags: (_c = playlist.resource.r.tags) === null || _c === void 0 ? void 0 : _c.map(ResourceClient_1.mapCreateTag),
                        },
                    },
                },
            });
            return (0, exports.mapPlaylistResponse)(data);
        });
    }
    deletePlaylist(playlistId) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'DELETE',
                url: urls_1.default.playlist(playlistId),
            });
            return data;
        });
    }
    movePlaylistToFolder(playlistId, folderId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.playlistMoveToFolder(playlistId),
                body: {
                    folder_id: folderId,
                },
            });
        });
    }
    getPlaylistPlaybackContent(playlistId) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.playlistPlaybackContent(playlistId),
            });
            return {
                playlistId: data.playlist_id,
                playlists: data.playlists &&
                    (0, mapObjectValues_1.default)(data.playlists, exports.mapPlaylistV2Response),
                presentations: data.presentations &&
                    (0, mapObjectValues_1.default)(data.presentations, PresentationClient_1.mapPresentationV2Response),
                applicationVersions: data.application_versions &&
                    (0, mapObjectValues_1.default)(data.application_versions, ApplicationClient_1.mapApplicationVersionResponse),
                themes: data.themes && (0, mapObjectValues_1.default)(data.themes, ThemeClient_1.mapThemeV2Response),
                applications: data.applications &&
                    (0, mapObjectValues_1.default)(data.applications, ApplicationClient_1.mapApplicationV2Response),
            };
        });
    }
    copyPlaylist(playlistId, params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.playlistCopy(playlistId),
                body: {
                    name: params.name,
                },
            });
            return (0, exports.mapPlaylistResponse)(data);
        });
    }
}
exports.default = PlaylistClient;
